import React from 'react';
import {useTranslation} from 'react-i18next';
import classes from '../courses.module.css';
import IntlMessage from '../../../components/IntlMessage/IntlMessage';
import useLocalizedText from '../hooks/useLocalizedText';
import {hoursLabelFull} from '../courses.utils';
import aituLogo from '../img/cert/aitu-logo-white.png';
import certDecor from '../img/cert/cert-decor.png';

/**
 * Превью сертификата, который получают участники.
 *
 * Повторяет реальный бланк из certs/any_template.html на бэкенде: альбомный лист
 * 29,7 × 21 см, синяя градиентная шапка с логотипом университета, центрированный
 * текст с подчёркнутым именем, номер и город внизу, фирменный знак в углу.
 * Пропорции взяты из шаблона напрямую (2,4 см заголовок при ширине 29,7 см и так
 * далее) и переведены в cqw, поэтому бланк выглядит одинаково при любой ширине блока.
 *
 * Градиент шапки не картинкой, а CSS: в оригинале это PNG на 418 КБ,
 * при этом обычный горизонтальный переход от #0073c7 к #0dbaf3.
 */
const CertificatePreview = ({course}) => {
    const {t} = useTranslation();
    const pick = useLocalizedText();

    return (
        <figure className={classes.certFigure}>
            <div className={classes.certSheet} aria-hidden="true">
                <div className={classes.certHeader}>
                    <img className={classes.certLogo} src={aituLogo} alt=""/>
                    <div className={classes.certWord}>
                        <IntlMessage id="coursesPage.course.certWord"/>
                    </div>
                </div>

                <div className={classes.certBody}>
                    <p className={classes.certLead}>
                        <IntlMessage id="coursesPage.course.certConfirms"/>
                    </p>
                    <p className={classes.certName}>
                        <IntlMessage id="coursesPage.course.certNamePlaceholder"/>
                    </p>
                    <p className={classes.certEvent}>
                        {t('coursesPage.course.certParticipated')}<br/>
                        «{pick(course.title)}»
                    </p>
                    <p className={classes.certPeriod}>
                        {t('coursesPage.course.certVolume', {hours: hoursLabelFull(course.durationHours)})}
                    </p>
                </div>

                <div className={classes.certFooter}>
                    <div className={classes.certNumber}>№ CCE-0000-2026</div>
                    <div>Астана, 2026</div>
                </div>

                <div className={classes.certQr}/>
                <img className={classes.certDecor} src={certDecor} alt=""/>
            </div>

            <figcaption className={classes.certCaption}>
                <IntlMessage id="coursesPage.course.certSample"/>
            </figcaption>
        </figure>
    );
};

export default CertificatePreview;
